import { gql } from '@apollo/client';

export const fetchWorkflowWebhookQuery = gql`
  query getWorkflowWebhook($id: Long!) {
    workflowWebhook(id: $id) {
      id
      name
      projectId
      headers {
        key
        value
      }
      updatedAt
      includeDefaultFields
      body {
        ... on WebhookCustomJsonBody {
          jsBody
        }
        ... on WebhookUserJsonField {
          field
        }
        ... on WebhookFormField {
          value
          key
        }
      }
      endpoint
      authType
      method
      contentType
      clientId
      clientSecret
      tokenEndpoint
      workflowNodes {
        id
        title
        workflow {
          id
          name
        }
      }
    }
  }
`;

export const fetchWorkflowWebhooksQuery = gql`
  query getWorkflowWebhooks($pagination: Pagination, $search: String, $sort: Sort) {
    workflowWebhooks(pagination: $pagination, search: $search, sort: $sort) {
      info {
        count
        limit
        offset
        page
      }
      results {
        id
        name
        projectId
        headers {
          key
          value
        }
        updatedAt
        includeDefaultFields
        body {
          ... on WebhookCustomJsonBody {
            jsBody
          }
          ... on WebhookUserJsonField {
            field
          }
          ... on WebhookFormField {
            value
            key
          }
        }
        endpoint
        authType
        method
        contentType
        clientId
        clientSecret
        tokenEndpoint
        workflowNodes {
          id
          title
          workflow {
            id
            name
          }
        }
      }
    }
  }
`;
